import { Component, effect, ElementRef, Inject, input, output, signal, ViewChild } from '@angular/core';
import { JSBridgeService } from '../../core/jsbridge.service';
import { DiffEditorModel } from 'ngx-monaco-editor-v2';
import { HistoryEntry } from '@server/src/types';
import { KopListService } from '../../core/kop-list.service';
import { removePrinterChars, uint8ArrayToString } from '../../utils/utils';
import { TranslateService } from '../../i18n/translate.service';
import { format } from 'date-fns';

@Component({
  selector: 'xmlcompare',
  templateUrl: './xmlcompare.component.html',
  styleUrl: './xmlcompare.component.css'
})
export class XMLCompareComponent {

  constructor(public jsBridgeService: JSBridgeService, private kopListService: KopListService, private translate: TranslateService, @Inject('i18n-label') private place: any) {
  }

  public isEditing = false;
  public isXML = false;
  public onDone = output<boolean>();


  @ViewChild('monaco') monaco: ElementRef | undefined;


  public options = {
  };
  public originalModel: DiffEditorModel = {
    code: 'heLLo world!',
    language: 'text/xml'
  };

  public modifiedModel: DiffEditorModel = {
    code: 'hello orlando!',
    language: 'text/xml'
  };


  public leftData: Record<string, any> = {};
  public rightData: Record<string, any> = {};

  public leftLabel: string = "";
  public rightLabel: string = "";


  private makeLabel(he: HistoryEntry) {
    if (he.id == undefined) {
      let translateRepo = this.translate.translateSignal();
      return this.translate.getTranslationSync(translateRepo, this.place, 'Last', 'Last');
    }
    let date = format(he.date, 'dd-MM-yyyy HH:mm:ss');
    return `${date} - ${he.user}  - ${he.comments}`;
  }
  public async open(left: HistoryEntry, right: HistoryEntry) {
    // this.diffXML();
    let leftData = await this.jsBridgeService.generateKopList(left.id);
    let rightData = await this.jsBridgeService.generateKopList(right.id);
    if (leftData == undefined || rightData == undefined) {
      return;
    }

    this.leftData = leftData;
    this.rightData = rightData;
    this.leftLabel = this.makeLabel(left);
    this.rightLabel = this.makeLabel(right);

    this.displayDiff();
    //console.log(leftData);
    this.isEditing = true;
  }

  public toggleXML() {
    this.isXML = !this.isXML;
    this.displayDiff();
  }
  public displayDiff() {
    if (this.isXML) {
      let leftXML = this.leftData[`/working/${this.jsBridgeService.getKlantNo()}.XML`];
      let rightXML = this.rightData[`/working/${this.jsBridgeService.getKlantNo()}.XML`];
      this.originalModel = {...this.originalModel, code: uint8ArrayToString(leftXML)};
      this.modifiedModel = {...this.modifiedModel, code: uint8ArrayToString(rightXML)};

    } else {
      let leftLST = this.leftData[`/working/LST/${this.jsBridgeService.getKlantNo()}.LST`];
      let rightLST = this.rightData[`/working/LST/${this.jsBridgeService.getKlantNo()}.LST`];
      this.originalModel = {...this.originalModel, code: removePrinterChars(uint8ArrayToString(leftLST))};
      this.modifiedModel = {...this.modifiedModel, code: removePrinterChars(uint8ArrayToString(rightLST))};
    }

  }
}
